import en from "./locales/en.json";
import nl from "./locales/nl-NL.json";
export default defineI18nConfig(() => {
  return {
    messages: {
      en,
      nl,
    },
  };
});
